import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";
import { removeTaskError } from "@planzone/dto";

function createInteractor(repository: Repository): Interactor {
  return (task) => {
    return present(
      repository
        .removeTask(task)
        .then(() => task)
        .catch((e) =>
          Promise.reject({
            error: { ...removeTaskError, ...e },
            task,
          }),
        ),
    );
  };
}

export type { Interactor };

export { createInteractor };
